import QuoteTypeOptions from './QuoteTypeOptions'

export default QuoteTypeOptions
